// Shared, deterministic tone derivation for group entities (Spaces, Circles,
// Networks). Each list/detail page used to roll its own hash + palette; this
// module is the single source of truth so the same Space/Circle/Network paints
// the same accent everywhere.

import type { Tone } from '@leanin/ui';

/**
 * Hash a stable identifier (UUID, slug, etc.) and project it onto the supplied
 * tone palette. Same id + same palette → same tone, deterministically.
 */
export function toneFromId(id: string, palette: ReadonlyArray<Tone>): Tone {
  if (palette.length === 0) {
    throw new Error('toneFromId: palette must not be empty');
  }
  let acc = 0;
  for (let i = 0; i < id.length; i += 1) {
    acc = (acc + id.charCodeAt(i)) >>> 0;
  }
  return palette[acc % palette.length]!;
}
